export default "__VITE_ASSET__BcEmleYB__"